export const verifyAccount  = gql`
    mutation verifyAccount(
        $email: String
        $token: String
    ) {
        verifyEmail(
            input:{
                email: $email,
                token: $token
            }) {
            token
        }
    }
`
